export enum ExercisesTypes {
    GET_LIST_EXERCISES = '@exercises/GET_LIST_EXERCISES',
    REQUEST_GET_LIST_EXERCISES = '@exercises/REQUEST_GET_LIST_EXERCISES',
    SAVE_EXERCISES = '@exercises/SAVE_EXERCISES',
    REQUEST_SAVE_EXERCISES = '@exercises/REQUEST_SAVE_EXERCISES',
    SAVE_EXERCISE = '@exercises/SAVE_EXERCISE',
    REQUEST_SAVE_EXERCISE = '@exercises/REQUEST_SAVE_EXERCISE',
    DELETE_EXERCISE = '@exercises/DELETE_EXERCISE',
    REQUEST_DELETE_EXERCISE = '@exercises/REQUEST_DELETE_EXERCISE',
}

export type Exercise = {
    id: string;
    backpack: boolean | false;
    visibleSavedExercises: boolean | false;
    description?: Record<string, string>;
    image: string | '';
    missionsToUnlock: string[] | null;
    name: Record<string, string>;
    renewalPercent: number;
    reward: string | '';
    tasks: string[] | null;
    skills: string[] | null;
};

export type ExercisesState = {
    isLoading: boolean;
    exercises: Exercise[];
};

export type ExercisesAction<Payload> = {
    type: ExercisesTypes;
    payload: Payload;
};

export type ExerciseReducer = (state: ExercisesState, actions: ExercisesAction<ExercisesState>) => ExercisesState;
